import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
  ) { }

  login(user_pass : any): Observable<{}> {
    this.removeAuthorizationToken();
    return this.http.post(this.apiUrl + '/authen/login-cxr', user_pass);
  }

  loginOne(user_pass : any): Observable<{}> {
    this.removeAuthorizationToken();
    return this.http.post(this.apiUrl + '/authen', user_pass);
  }

  removeAuthorizationToken() {
    localStorage.clear();
  }

  setAuthorizationToken(token) {
    localStorage.setItem('access_token', token['access_token_cxr']);
    localStorage.setItem('refresh_token', token['refresh_token']);
    localStorage.setItem('expiration_date', token['expiration_date']);
    localStorage.setItem('account_id', token['account_id']);
    localStorage.setItem('role', token['role']);
    localStorage.setItem('username', token['username']);
    localStorage.setItem('hospital_id', token['hospital_id']);
    localStorage.setItem('status', token['status']);

    // // console.log(localStorage.getItem('hospitals'))
    if (localStorage.getItem('hospital') === null) {
      // console.log(localStorage.setItem('hospitals', JSON.stringify(token['hospitals'])));
      localStorage.setItem('hospital', JSON.stringify(token['hospital']));
    }

  }

  getRole() {
    return localStorage.getItem('role');
  }

  getUser(): any {
    return localStorage.getItem('username');
  }

  isLoggedIn(): boolean {
    /** Check valid parameter */
    const access_token = localStorage.getItem('access_token');
    const refresh_token = localStorage.getItem('refresh_token');
    const expire_at = localStorage.getItem('expiration_date');  
    
    if (access_token != undefined && refresh_token != undefined && expire_at != undefined) {
      return true;
    }
    return false;
  }
}
